import { connect } from 'react-redux';
import DimensionForm from './DimensionForm';
import { Member } from 'src/types/Scope';
import type { AppThunkDispatch } from 'src/store.types';
import type { AppState } from 'src/reducers';
import { changeScopeSelection, clearFloorsetAndQuickSelect } from '../AssortmentScopeSelector.slice';
import { Perspective } from 'configuration-schemas/bindings.types';
import { sortBy } from 'lodash';

export interface DispatchProps {
  onChangeProductLevel(productLevelId: string): void;
  onChangeProductMember(productMemberId: string): void;
  onChangeLocationLevel(locationLevelId: string): void;
  onChangeLocationMember(locationMemberId: string): void;
}

export interface RouteProps {
  perspective: Perspective;
}

function mapStateToProps(state: AppState) {
  const { selections, selectionErrors } = state.scope;
  let productLevels: Member[] = [];
  let locationLevels: Member[] = [];
  if (state.scope.dimensionHierConfig) {
    productLevels = sortBy(state.scope.dimensionHierConfig.product, 'name');
    locationLevels = sortBy(state.scope.dimensionHierConfig.location, 'name');
  }

  return {
    selectionErrors,
    // SPIKE: do we need to sort these by name like previously?
    productLevels,
    locationLevels,
    selectedProductMember: selections.productMember,
    selectedLocationMember: selections.locationMember,
  };
}

function mapDispatchToProps(dispatch: AppThunkDispatch): DispatchProps {
  return {
    onChangeProductLevel(productLevel: string): void {
      dispatch(changeScopeSelection({ productLevel }));
    },
    onChangeProductMember(productMember: string): void {
      dispatch(changeScopeSelection({ productMember }));
      dispatch(clearFloorsetAndQuickSelect());
    },
    onChangeLocationLevel(locationLevel: string): void {
      dispatch(changeScopeSelection({ locationLevel }));
    },
    onChangeLocationMember(locationMember: string): void {
      dispatch(changeScopeSelection({ locationMember }));
    },
  };
}
export interface StateProps extends ReturnType<typeof mapStateToProps> {}
export default connect(mapStateToProps, mapDispatchToProps)(DimensionForm);
